import { Container, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography, Card, CardContent, Box, Grid, Button, TextField, Select, MenuItem, Autocomplete, Chip, Dialog, DialogTitle, DialogContent, DialogActions, Alert, FormControl, InputLabel } from "@mui/material";
import React, { useEffect, useState, useRef } from "react";
import { useParams } from "react-router-dom";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { toast } from 'react-toastify';
import { useNavigate, Link } from "react-router-dom";
import axios from 'axios';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import NoteIcon from '@mui/icons-material/Note';
import LabelIcon from '@mui/icons-material/Label';
import WarningIcon from '@mui/icons-material/Warning';
import Order from "../../models/order";
import Products from "../../collections/products";
import UserPackage from "../../models/user_package";
import UserPackages from "../../collections/user_packages";
import { DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import Account from '../../models/account';
import Accounts from '../../collections/accounts';
import { jwtDecode } from "jwt-decode";
import TagInput from '../common/TagInput';
import OrderActivityHistory from './OrderActivityHistory';
import Invoices from '../../collections/invoices';
import OrderInvoiceActions from './OrderInvoiceActions';

const OrderDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [orderInvoice, setOrderInvoice] = useState(null);

  // Load the existing (active) invoice for this order, if any, so the invoice
  // card can switch between "Tạo hóa đơn" and "Xem hóa đơn".
  const fetchOrderInvoice = async () => {
    try {
      const list = await new Invoices().fetch(1, 1, { order_id: id });
      return (list || []).find((inv) => inv.status !== 'CANCELLED') || null;
    } catch (e) {
      return null;   // no invoice yet
    }
  };

  useEffect(() => {
    let active = true;
    (async () => {
      const found = await fetchOrderInvoice();
      if (active && found) setOrderInvoice(found);
    })();
    return () => { active = false; };
  }, [id]);

  // Re-read the order + its invoice after an invoice action changed either one.
  const refreshOrderAndInvoice = async () => {
    const [data, invoice] = await Promise.all([
      new Order().getOrderById(id),
      fetchOrderInvoice(),
    ]);
    if (data?.data) setOrder(data.data);
    setOrderInvoice(invoice);
  };
  const [isRecording, setIsRecording] = useState(false);
  const [videoUrl, setVideoUrl] = useState('');
  const [isVideoRecorded, setIsVideoRecorded] = useState(false);
  const mediaRecorderRef = useRef(null);
  const videoStreamRef = useRef(null);
  const chunks = useRef([]);
  const [packingVideo, setPackingVideo] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [editedOrder, setEditedOrder] = useState({
    shipping_address: '',
    phone_number: '',
    shipping_price: '',
    order_type: ''
  });
  const [products, setProducts] = useState([]);
  const [orderItems, setOrderItems] = useState({ id: 1, product: '', quantity: '', note: '', order_type: 'INSTANT_ORDER' });
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedQuantity, setEditedQuantity] = useState(null);
  const [editedOrderType, setEditedOrderType] = useState(null);
  const [orderLineId, setOrderLineId] = useState(null);
  const [isAddProduct, setIsAddProduct] = useState(true);
  const [dateRange, setDateRange] = useState();
  const [userPackage, setUserPackage] = useState([]);
  const [userPackages, setUserPackages] = useState([]);
  const [editedNote, setEditedNote] = useState(null);
  // Inventory confirmation dialog state
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [inventoryWarnings, setInventoryWarnings] = useState([]);
  const [pendingLineItem, setPendingLineItem] = useState(null);
  // Packer reassignment (admin-only)
  const [userRole, setUserRole] = useState(null);
  const [isChangingPacker, setIsChangingPacker] = useState(false);
  const [activeAccounts, setActiveAccounts] = useState([]);
  const [selectedPackerId, setSelectedPackerId] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      setUserRole(jwtDecode(token).role);
    }
  }, []);

  // Refetch the order and re-resolve the display names the API does not include
  // (creator, invoice sender, packer); a plain setOrder(data.data) after a
  // status change would silently drop them.
  const refreshOrderWithNames = async () => {
    const fetchOrder = new Order();
    const data = await fetchOrder.getOrderById(id);
    const getAccountName = async (accountId) => {
      if (!accountId) return null;
      const accountModel = new Account();
      const accountData = await accountModel.getAccountById(accountId);
      return accountData && accountData.name ? accountData.name : null;
    };
    const [createdByName, invoiceSentByName, packagedByName] = await Promise.all([
      getAccountName(data.data.created_by),
      getAccountName(data.data.sent_invoice_by),
      getAccountName(data.data.packaged_by),
    ]);
    setOrder({
      ...data.data,
      created_by_name: createdByName || 'N/A',
      invoice_sent_by_name: invoiceSentByName || 'N/A',
      packaged_by_name: packagedByName || 'N/A',
    });
  };

  useEffect(() => {
    const fetchOrderDetail = async () => {
      const fetchOrder = new Order();
      const data = await fetchOrder.getOrderById(id);
      setOrder(data.data);
      setVideoUrl(data.packing_video);
      setEditedOrder({
        shipping_address: data.data.shipping_address,
        phone_number: data.data.phone_number,
        shipping_price: data.data.shipping_price,
        order_type: data.data.order_type,
        note: data.data.note,
        processed_at: data.data.processed_at,
        tags: data.data.tags || '',
      });

      // --- Fetch and map creator, invoice sender, and packager info (like in Orders.js) ---
      // Get creator, invoice sender, and packager IDs
      const creatorId = data.data.created_by;
      const invoiceSenderId = data.data.sent_invoice_by;
      const packagedById = data.data.packaged_by;
      // Use a cache to avoid duplicate fetches (in-memory for this component)
      const accountCache = {};
      // Helper to fetch account name
      async function getAccountName(accountId) {
        if (!accountId) return null;
        if (accountCache[accountId]) return accountCache[accountId].name;
        const accountModel = new Account();
        const accountData = await accountModel.getAccountById(accountId);
        if (accountData && accountData.name) {
          accountCache[accountId] = accountData;
          return accountData.name;
        }
        return null;
      }
      // Set names on order object for display
      let createdByName = null;
      let invoiceSentByName = null;
      let packagedByName = null;
      if (creatorId) createdByName = await getAccountName(creatorId);
      if (invoiceSenderId) invoiceSentByName = await getAccountName(invoiceSenderId);
      if (packagedById) packagedByName = await getAccountName(packagedById);
      setOrder(prev => ({
        ...prev,
        created_by_name: createdByName || prev.created_by_name || 'N/A',
        invoice_sent_by_name: invoiceSentByName || prev.invoice_sent_by_name || 'N/A',
        packaged_by_name: packagedByName || prev.packaged_by_name || 'N/A',
      }));

      // Load user package if order has a user
      if (data.data.user?.id) {
        const userPackages = new UserPackages();
        try {
          await userPackages.fetch(1, 1000, {user_id: data.data.user.id});
          if (userPackages.size() > 0) {
            setUserPackages(userPackages.items);
          }
        } catch (error) {
          console.error("Error loading user package:", error);
        }

        const userPackageInstance = new UserPackage();
        try {
          const activePackage = await userPackageInstance.getActivePackageByUserId(data.data.user.id);
          if (activePackage) {
            setUserPackage(activePackage);
          }
        } catch (error) {
          console.error("Error loading user package:", error);
        }
      }
    };
    fetchOrderDetail();
  }, [id, isEditing, isAddProduct, editingIndex]);
  useEffect(() => {
    const fetchProducts = async () => {
      const listProducts = new Products();
      await listProducts.fetch('ACTIVE'); // Only fetch active products for order editing
      setProducts(listProducts.items);
    }
    fetchProducts();
  }, [])

  // Set default order_type for new line items based on parent order type
  useEffect(() => {
    if (order?.order_type) {
      setOrderItems(prev => ({ ...prev, order_type: order.order_type }));
    }
  }, [order?.order_type])

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      videoStreamRef.current.srcObject = stream;
      videoStreamRef.current.play();
      const options = { mimeType: 'video/webm; codecs=vp8' };;
      const mediaRecorder = new MediaRecorder(stream, options);
      mediaRecorderRef.current = mediaRecorder;
      chunks.current = [];
      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          chunks.current.push(event.data);
        }
      };
      mediaRecorder.start();
      setIsRecording(true);
    } catch (error) {
      console.error('Error accessing media devices.', error);
    }
  };
  const handleStopRecording = () => {
    mediaRecorderRef.current.stop();
    videoStreamRef.current.srcObject.getTracks().forEach(track => track.stop());
    videoStreamRef.current.style.display = 'none';
    mediaRecorderRef.current.onstop = () => {
      const blob = new Blob(chunks.current, { type: chunks.current[0]?.type || 'video/webm' });
      const videoUrl = URL.createObjectURL(blob);
      setVideoUrl(videoUrl);
      setPackingVideo(blob);
      setIsVideoRecorded(true);
    };
    setIsRecording(false);
  };
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('vi-VN', options);
  };
  const formatDateTime = (dateString) => {
    const options = {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    };
    return new Date(dateString).toLocaleString('vi-VN', options);
  };
  const uploadVideo = async () => {
    let formData = new FormData();
    formData.append('file', packingVideo, 'packing-video.webm');
    let config = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: 'https://api.maysfarm.vn/api/v1/images',
      headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MSwiZW1haWwiOiJuZ3V5ZW50aGFpMjgxMUBnbWFpbC5jb20iLCJyb2xlIjoiQURNSU4iLCJleHAiOjEwMDAwMDAwMDAwMDE3MjQ4NDY5NTh9.KtSXIt4Du_lhqfZNwyGCETlCW9BaIXUujjSW60SfaqY',
      },
      data: formData
    };
    try {
      const res = await axios.request(config);
      return res.data.data;
    }
    catch (error) {
      throw error;
    }
  }
  const handleSendVideo = async () => {
    const video = await uploadVideo();
    const sendVideo = new Order();
    try {
      const response = await sendVideo.addPackingVideoById(id, video);
      if (response.success) {
        toast.success(response.messenge, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        navigate("/orders");
      }
    }
    catch (error) {
      throw error;
    }
  };
  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(amount).replace("₫", "");
  };
  const handleEditToggle = async () => {
    if (!isEditing) {
      // Fetch user packages when entering edit mode
      if (order.user?.id) {
        const userPackagesList = new UserPackages();
        try {
          await userPackagesList.fetch(1, 100, { user_id: order.user.id, status: 'ACTIVE' });
          setUserPackages(userPackagesList.items);
        } catch (error) {
          console.error("Error loading user packages:", error);
        }
      }
    }
    setIsEditing(!isEditing);
  };
  const handleInputChange = (field, value) => {
    if (field === 'order_type') {
      if (value === 'MONTHLY_PACKAGE_ORDER') {
        if (!userPackage) {
          toast.error("Người dùng không có gói tháng đang hoạt động", {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          return;
        }
        setEditedOrder(prev => ({
          ...prev,
          [field]: value,
          user_package_id: userPackage.id
        }));
      } else { // INSTANT_ORDER
        setEditedOrder(prev => ({
          ...prev,
          [field]: value,
          user_package_id: null
        }));
      }
    } else {
      setEditedOrder(prev => ({
        ...prev,
        [field]: value
      }));
    }
  };
  const handleCancelEdit = () => {
    setIsEditing(false);
    setEditedOrder({
      shipping_address: order.shipping_address,
      phone_number: order.phone_number,
      shipping_price: order.shipping_price,
      order_type: order.order_type,
      processed_at: order.processed_at,
      tags: order.tags || '',
    });
  };
  const handleConfirmEdit = async () => {
    const newOrder = new Order({
      shipping_price: editedOrder.shipping_price,
      shipping_address: editedOrder.shipping_address,
      phone_number: editedOrder.phone_number,
      order_type: editedOrder.order_type,
      note: editedOrder.note,
      processed_at: dateRange,
      user_package_id: editedOrder?.user_package_id || userPackage?.id || null,
      tags: editedOrder.tags,
    })
    try {
      const res = await newOrder.updateOrder(id);
      if (res.success) {
        toast.success(res.messenge, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        navigate(`/orders/${id}`);
      }
    }
    catch (error) {
      toast.error("Đã xảy ra lỗi, vui lòng thử lại", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      navigate(`/orders/${id}`);
    }
    setIsEditing(false);
  };
  const handleQuantityChange = (value) => {
    setOrderItems({ ...orderItems, quantity: value });
  };

  const handleNoteChange = (value) => {
    setOrderItems({ ...orderItems, note: value });
  };

  const handleRemoveItem = () => {
    setOrderItems({ id: 1, product: '', quantity: '', note: '', order_type: order?.order_type || 'INSTANT_ORDER' });
  };
  const handleProductChange = (value) => {
    const newItems = { ...orderItems };
    newItems.product = value;
    setOrderItems(newItems);
  };
  const handleAddProduct = async () => {
    // Check for duplicate product in existing order line items
    const existingProduct = order.order_line_items.find(
      item => item.product_id === orderItems.product
    );
    if (existingProduct) {
      const productName = existingProduct.product?.name || orderItems.product;
      toast.error(`Sản phẩm "${productName}" đã có trong đơn hàng. Vui lòng cập nhật số lượng thay vì thêm mới.`, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return;
    }

    const orderInstance = new Order();
    try {
      const orderLineItem = {
        product_id: orderItems.product,
        quantity: parseFloat(orderItems.quantity),
        note: orderItems.note,
        order_type: orderItems.order_type
      };

      const res = await orderInstance.addOrderLineItems(id, orderLineItem);
      if (res.success) {
        toast.success(res.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setIsAddProduct(true);
        setOrderItems({ id: 1, product: '', quantity: '', note: '', order_type: order?.order_type || 'INSTANT_ORDER' });
      } else if (res.requires_confirmation) {
        // Show confirmation dialog with inventory warnings
        setInventoryWarnings(res.inventory_warnings);
        setPendingLineItem(orderLineItem);
        setConfirmDialogOpen(true);
      }
    }
    catch (error) {
      toast.error("Đã xảy ra lỗi, vui lòng thử lại", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      navigate(`/orders/${id}`);
    }
  }

  const handleConfirmAddProduct = async () => {
    if (!pendingLineItem) return;

    const orderInstance = new Order();
    try {
      const res = await orderInstance.addOrderLineItems(id, pendingLineItem, true); // force_create = true
      if (res.success) {
        toast.success(res.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setConfirmDialogOpen(false);
        setPendingLineItem(null);
        setInventoryWarnings([]);
        setIsAddProduct(true);
        setOrderItems({ id: 1, product: '', quantity: '', note: '', order_type: order?.order_type || 'INSTANT_ORDER' });
      } else {
        toast.error(res.message || "Đã xảy ra lỗi", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      let errorMessage = "Đã xảy ra lỗi không xác định!";
      if (error.response?.data?.error) {
        if (Array.isArray(error.response.data.error)) {
          errorMessage = error.response.data.error.join(", ");
        } else if (typeof error.response.data.error === "string") {
          errorMessage = error.response.data.error;
        }
      }
      toast.error(errorMessage, {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleCancelConfirm = () => {
    setConfirmDialogOpen(false);
    setPendingLineItem(null);
    setInventoryWarnings([]);
  }

  const handleClickAddProduct = () => {
    if (!isAddProduct) {
      // When opening the add product form, set default order_type based on parent order
      setOrderItems({ id: 1, product: '', quantity: '', note: '', order_type: order.order_type || 'INSTANT_ORDER' });
    }
    setIsAddProduct(!isAddProduct);
  }

  const handleEditQuantity = (index, quantity, orderType, note) => {
    setEditingIndex(index);
    setEditedQuantity(quantity);
    setEditedOrderType(orderType);
    setEditedNote(note);
  };

  const handleCancelEditQuantity = () => {
    setEditingIndex(null);
    setEditedQuantity(null);
    setEditedOrderType(null);
    setOrderLineId(null);
  };

  const handleChangeQuantity = async () => {
    const order = new Order();
    try {
      const orderLineItem = {
        quantity: parseFloat(editedQuantity),
        order_type: editedOrderType,
        note: editedNote,
      };
      console.log(orderLineItem);
      const res = await order.updateOrderLineItems(orderLineId, orderLineItem);
      if (res.success) {
        toast.success(res.message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setEditingIndex(null);
        setEditedQuantity(null);
        setOrderLineId(null);
      }
    }
    catch (error) {
      toast.error("Đã xảy ra lỗi, vui lòng thử lại", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setEditingIndex(null);
      setEditedQuantity(null);
      setOrderLineId(null);
    }
  }

  const handleDeleteOrderLineItems = async () => {
    const order = new Order();
    try {
      const orderLineItem = {
        quantity: 0 // Set quantity to 0 to delete the line item
      };

      const res = await order.updateOrderLineItems(orderLineId, orderLineItem);
      if (res.success) {
        toast.success("Xóa sản phẩm thành công", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setEditingIndex(null);
        setEditedQuantity(null);
        setOrderLineId(null);
      }
    }
    catch (error) {
      toast.error("Đã xảy ra lỗi, vui lòng thử lại", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      setEditingIndex(null);
      setEditedQuantity(null);
      setOrderLineId(null);
    }
  }

  const handleCancelOrder = () => {
    toast.info(
      () => <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <p>Bạn có chắc chắn muốn hủy đơn hàng này?</p>
        <Box display="flex" gap={2} mt={2}>
          <Button
            variant="contained"
            color="error"
            onClick={async () => {
              try {
                const orderModel = new Order();
                const res = await orderModel.cancelOrder(id);
                if (res.success) {
                  toast.success(res.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  navigate("/orders");
                } else {
                  toast.error(res.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                }
              } catch (error) {
                toast.error("Đã xảy ra lỗi khi hủy đơn hàng", {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
              }
              toast.dismiss();
            }}
          >
            Xác nhận hủy
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              toast.dismiss();
            }}
          >
            Không
          </Button>
        </Box>
      </Box>,
      {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      }
    );
  };

  const handleMarkAsPackaged = async () => {
    try {
      const orderModel = new Order();
      const res = await orderModel.addPackingVideoById(id, null);
      if (res.success) {
        toast.success("Đã đánh dấu đơn hàng là đã đóng gói", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        // Reload the order details
        const fetchOrder = new Order();
        const data = await fetchOrder.getOrderById(id);

        // Fetch packaged_by name
        const packagedById = data.data.packaged_by;
        let packagedByName = null;
        if (packagedById) {
          const accountModel = new Account();
          const accountData = await accountModel.getAccountById(packagedById);
          if (accountData && accountData.name) {
            packagedByName = accountData.name;
          }
        }

        setOrder({
          ...data.data,
          packaged_by_name: packagedByName || 'N/A',
        });
      } else {
        toast.error("Không thể đánh dấu đơn hàng", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
      }
    } catch (error) {
      console.error("Error marking as packaged:", error);
      toast.error("Đã xảy ra lỗi khi đánh dấu đơn hàng", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
  };

  const handleOpenChangePacker = async () => {
    try {
      if (activeAccounts.length === 0) {
        const accounts = new Accounts();
        await accounts.fetch();
        setActiveAccounts(accounts.items.filter((a) => a.status === 'ACTIVE'));
      }
      setSelectedPackerId(order.packaged_by || '');
      setIsChangingPacker(true);
    } catch (error) {
      console.error("Error loading accounts:", error);
      toast.error("Không thể tải danh sách nhân viên", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleChangePacker = async () => {
    try {
      const orderModel = new Order();
      const res = await orderModel.updatePackagedBy(id, selectedPackerId);
      if (res && res.success) {
        const selected = activeAccounts.find((a) => a.id === selectedPackerId);
        setOrder(prev => ({
          ...prev,
          packaged_by: selectedPackerId,
          packaged_by_name: selected ? selected.name : prev.packaged_by_name,
        }));
        setIsChangingPacker(false);
        toast.success("Đã thay đổi người đóng gói", {
          position: "top-center",
          autoClose: 3000,
        });
      } else {
        toast.error("Không thể thay đổi người đóng gói", {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (error) {
      console.error("Error changing packer:", error);
      toast.error("Đã xảy ra lỗi khi thay đổi người đóng gói", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  const handleConfirmOrder = () => {
    toast.info(
      () => <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
        <p>Xác nhận đơn hàng này? Tồn kho sẽ được trừ.</p>
        <Box display="flex" gap={2} mt={2}>
          <Button
            variant="contained"
            color="success"
            onClick={async () => {
              toast.dismiss();
              try {
                const orderModel = new Order();
                const result = await orderModel.confirmOrder(id);
                if (result.success) {
                  toast.success(result.message);
                  await refreshOrderWithNames();
                } else {
                  toast.error(result.message);
                }
              } catch (err) {
                toast.error('Có lỗi xảy ra khi xác nhận đơn hàng');
              }
            }}
          >
            Xác nhận
          </Button>
          <Button variant="outlined" onClick={() => toast.dismiss()}>
            Hủy
          </Button>
        </Box>
      </Box>,
      { autoClose: false, closeOnClick: false, position: "top-center" }
    );
  };

  const handleForceToOpen = () => {
    toast.info(
      () => <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
      >
        <p>Bạn có chắc chắn muốn chuyển đơn hàng này về trạng thái mới (OPEN)?</p>
        <Typography variant="body2" color="warning.main" sx={{ mt: 1, mb: 2, textAlign: 'center' }}>
          Lưu ý: Thao tác này sẽ chuyển đơn hàng về trạng thái đơn mới mà không ảnh hưởng đến
          trạng thái thanh toán hoặc các thông tin khác.
        </Typography>
        <Box display="flex" gap={2} mt={2}>
          <Button
            variant="contained"
            color="warning"
            onClick={async () => {
              try {
                const orderModel = new Order();
                const res = await orderModel.forceUpdateToOpen(id);
                if (res.success) {
                  toast.success(res.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                  // Reload the order details
                  await refreshOrderWithNames();
                } else {
                  toast.error(res.message, {
                    position: "top-center",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                  });
                }
              } catch (error) {
                toast.error("Đã xảy ra lỗi khi chuyển trạng thái đơn hàng", {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                });
              }
              toast.dismiss();
            }}
          >
            Xác nhận chuyển trạng thái
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              toast.dismiss();
            }}
          >
            Hủy
          </Button>
        </Box>
      </Box>,
      {
        position: "top-center",
        autoClose: false,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      }
    );
  };
  if (!order) {
    return <Typography>Đang tải...</Typography>;
  }
  return (
    <Container sx={{ mt: 3, mb: 5, px: { xs: 1, sm: 2, md: 3 } }}>
      <Card elevation={3}>
        <CardContent sx={{ p: 4 }}>
          <Box display="flex" alignItems="center" mb={4}>
            <Grid container alignItems="center">
              <Grid item xs={12} md={6} display="flex" alignItems="center">
                <ShoppingCartIcon color="primary" sx={{ mr: 2, fontSize: '2rem' }} />
                <Typography variant="h4" sx={{ fontWeight: 'medium' }}>
                  Chi tiết đơn hàng #{order.name}
                </Typography>
              </Grid>
              <Grid item xs={12} md={6} display="flex" justifyContent="flex-end" sx={{ mt: { xs: 2, md: 0 } }}>
                {order.status === "CONFIRMING" && (
                  <>
                    <Button
                      variant="contained"
                      color="success"
                      onClick={handleConfirmOrder}
                      sx={{ mr: 1 }}
                    >
                      Xác nhận đơn hàng
                    </Button>
                    <Button
                      variant="contained"
                      color="error"
                      onClick={handleCancelOrder}
                      startIcon={<DeleteIcon />}
                      sx={{ mr: 1 }}
                    >
                      Hủy đơn hàng
                    </Button>
                  </>
                )}
                {order.status !== "CONFIRMING" && (order.status === "OPEN" || order.status === "PACKAGED") && order.financial_status !== "PAID" && (
                  <Button
                    variant="contained"
                    color="error"
                    onClick={handleCancelOrder}
                    startIcon={<DeleteIcon />}
                    sx={{ mr: 1 }}
                  >
                    Hủy đơn hàng
                  </Button>
                )}
                {order.status !== "CONFIRMING" && order.status !== "OPEN" && (
                  <Button
                    variant="contained"
                    color="warning"
                    onClick={handleForceToOpen}
                    sx={{ mr: 1 }}
                  >
                    Chuyển về trạng thái mới
                  </Button>
                )}
              </Grid >
            </Grid >
          </Box >
          <Card variant="outlined" sx={{ mb: 3, p: 3, bgcolor: '#f8f9fa' }}>
            <Grid container spacing={2} sx={{ mb: 3 }}>
              <Grid item xs={12} sm={12}>
                <Typography variant="h6" gutterBottom color="primary">
                  Thông tin khách hàng
                </Typography>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <Typography variant="body1">
                      <strong>Tên khách hàng:</strong>{' '}
                      {order.user ? (
                        <Button
                          component={Link}
                          to={`/customers/${order.user.id}`}
                          sx={{
                            p: 0,
                            textTransform: 'none',
                            color: 'primary.main',
                            '&:hover': {
                              textDecoration: 'underline',
                              background: 'none'
                            }
                          }}
                        >
                          {order.user.name}
                        </Button>
                      ) : (
                        'N/A'
                      )}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Email:</strong> {order.user?.email || 'N/A'}
                    </Typography>
                  </Grid >
                  <Grid item xs={12} sm={6}>
                    <Typography variant="body1">
                      <strong>Số điện thoại:</strong> {order.user?.phone_number || order.phone_number || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Số điện thoại dự phòng:</strong> {order.user?.backup_phone_number || 'N/A'}
                    </Typography>
                    <Typography variant="body1">
                      <strong>Địa chỉ:</strong> {order.user?.address || 'N/A'}
                    </Typography>
                  </Grid >
                  {order.user?.note && (
                    <Grid item xs={12}>
                      <Typography variant="body1">
                        <strong>Ghi chú khách hàng:</strong> {order.user.note}
                      </Typography>
                    </Grid>
                  )}
                  <Grid item xs={12} sm={12}>
                    {order.order_type === 'MONTHLY_PACKAGE_ORDER' && (
                      userPackage ? (
                        <Box sx={{ mt: 1, p: 1, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                          <Typography variant="subtitle2" color="primary">
                            <strong>Thông tin gói tháng đang hoạt động:</strong>
                          </Typography>
                          <Typography variant="body2">
                            Tên gói:{' '}
                            {userPackage.package ? (
                              <Button
                                component={Link}
                                to={`/user-packages/${userPackage.id}`}
                                sx={{
                                  p: 0,
                                  textTransform: 'none',
                                  color: 'primary.main',
                                  '&:hover': {
                                    textDecoration: 'underline',
                                    background: 'none'
                                  }
                                }}
                              >
                                {userPackage.package.name}
                              </Button>
                            ) : 'N/A'}
                          </Typography>
                          <Typography variant="body2">
                            Ngày bắt đầu: {formatDate(userPackage.beginning_date)}
                          </Typography>
                          <Typography variant="body2">
                            Trạng thái: {userPackage.status}
                          </Typography>
                          <Typography variant="body2">
                            Ngày kết thúc: {formatDate(userPackage.ending_date)}
                          </Typography>
                        </Box>
                      ) : (
                        <Box sx={{ mt: 1, p: 1, bgcolor: '#ffebee', borderRadius: 1, border: '1px solid #ffcdd2' }}>
                          <Typography variant="subtitle2" color="error">
                            <strong>Thông tin gói tháng:</strong>
                          </Typography>
                          <Typography variant="body2" color="error">
                            Khách hàng hiện không có gói tháng đang hoạt động
                          </Typography>
                        </Box>
                      )
                    )}
                  </Grid>
                </Grid >
              </Grid >
            </Grid >
          </Card >
          <Card variant="outlined" sx={{ mb: 3, p: 3, bgcolor: '#f8f9fa' }}>
            <Box sx={{
              borderBottom: '2px solid #1976d2',
              pb: 1,
              mb: 3
            }}>
              <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid item xs={12} sm={6} md={4}>
                  <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1 }}>
                    <Typography variant="h6" color="primary">
                      Thông tin đơn hàng
                    </Typography>
                    <Typography
                      component="span"
                      sx={{
                        px: 1.5,
                        py: 0.5,
                        borderRadius: 1,
                        fontSize: '0.875rem',
                        fontWeight: 'medium',
                        bgcolor: order.status === 'OPEN' ? '#fff3e0' :
                          order.status === 'PACKAGED' ? '#e3f2fd' :
                            order.status === 'SENT_INVOICE' ? '#e8f5e9' :
                              order.status === 'CANCELLED' ? '#ffebee' : '#f5f5f5',
                        color: order.status === 'OPEN' ? '#f57c00' :
                          order.status === 'PACKAGED' ? '#1976d2' :
                            order.status === 'SENT_INVOICE' ? '#2e7d32' :
                              order.status === 'CANCELLED' ? '#d32f2f' : 'text.primary'
                      }}
                    >
                      {order.status === 'OPEN' ? 'Đơn mới' :
                        order.status === 'PACKAGED' ? 'Đã đóng gói' :
                          order.status === 'SENT_INVOICE' ? 'Đã gửi hóa đơn' :
                            order.status === 'CANCELLED' ? 'Đã hủy' : order.status}
                    </Typography>
                    {/* S13: order-level HDDT status, right beside the order status */}
                    {order.hddt_status && order.hddt_status !== 'none' && (
                      <Typography
                        component="span"
                        sx={{
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          fontSize: '0.875rem',
                          fontWeight: 'medium',
                          bgcolor: order.hddt_status === 'signed' ? '#e8f5e9' :
                            order.hddt_status === 'draft' ? '#ede7f6' : '#f5f5f5',
                          color: order.hddt_status === 'signed' ? '#2e7d32' :
                            order.hddt_status === 'draft' ? '#5e35b1' : 'text.primary'
                        }}
                      >
                        {order.hddt_status === 'signed' ? 'HDDT đã ký' :
                          order.hddt_status === 'draft' ? 'HDDT nháp' :
                            order.hddt_status === 'adjusted' ? 'HDDT điều chỉnh' :
                              `HDDT ${order.hddt_status}`}
                      </Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <Box sx={{ mb: 2 }}>
                    <Grid container spacing={2}>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Người tạo đơn:</strong> {order.created_by_name || order.created_by?.name || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Ngày đặt hàng:</strong> {order.created_at ? formatDate(order.created_at) : 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Người gửi hóa đơn:</strong> {order.invoice_sent_by_name || order.invoice_sent_by?.name || 'N/A'}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={3}>
                        <Typography variant="body2" color="text.secondary">
                          <strong>Thời gian gửi hóa đơn:</strong> {order.sent_invoice_at ? formatDate(order.sent_invoice_at) : 'N/A'}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{
                    display: 'flex',
                    justifyContent: { xs: 'flex-start', md: 'flex-end' },
                    mt: { xs: 1, md: 0 }
                  }}>
                    {
                      order.status !== "SENT_INVOICE" && order.financial_status !== "PAID" && !order.paid_proof && order.status !== "CANCELLED" && (
                        !isEditing ? (
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleEditToggle}
                            size="small"
                            fullWidth={false}
                            sx={{ minWidth: 'auto' }}
                          >
                            Chỉnh sửa đơn hàng
                          </Button>
                        ) : (
                          <Box sx={{
                            display: 'flex',
                            gap: 1,
                            flexDirection: { xs: 'column', sm: 'row' },
                            width: { xs: '100%', sm: 'auto' }
                          }}>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={handleCancelEdit}
                              size="small"
                            >
                              Hủy chỉnh sửa
                            </Button>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={handleConfirmEdit}
                              size="small"
                            >
                              Lưu chỉnh sửa
                            </Button>
                          </Box>
                        )
                      )
                    }
                  </Box>
                </Grid>
              </Grid>
            </Box>
            <Grid container spacing={3} sx={{ pb: 1 }}>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 1,
                    bgcolor: 'white',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  }}
                >
                  <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <DateRangeIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                        Ngày xử lý: <Typography component="span" color="text.secondary">{formatDate(order.processed_at)}</Typography>
                      </Typography>
                    ) : (
                      <DatePicker
                        label="Ngày xử lý"
                        value={editedOrder.processed_at ? dayjs(editedOrder.processed_at, "YYYY-MM-DDTHH:mm:ss") : null}
                        onChange={(newValue) => {
                          if (newValue) {
                            const formattedDate = newValue.format("YYYY-MM-DDTHH:mm:ss");
                            setDateRange(formattedDate);
                          }
                        }}
                        renderInput={
                          (params) => <TextField {...params}
                            sx={{ height: "30px" }}
                          />}
                        inputFormat="DD/MM/YYYY"
                        sx={{ width: '100%', ml: 1, height: '40px', mb: '5px' }}
                      />
                    )}
                  </Box>
                  <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                        Loại đơn hàng:{' '}
                        <Typography component="span" color="text.secondary">
                          {order.order_type === 'INSTANT_ORDER' ? 'Mua lẻ' : 'Gói tháng'}
                        </Typography>
                      </Typography>
                    ) : (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, ml: 1 }}>
                        <Select
                          fullWidth
                          size="small"
                          value={editedOrder.order_type}
                          onChange={(e) => handleInputChange('order_type', e.target.value)}
                        >
                          <MenuItem value="MONTHLY_PACKAGE_ORDER">Gói Tháng</MenuItem>
                          <MenuItem value="INSTANT_ORDER">Mua Lẻ</MenuItem>
                        </Select>
                        
                        {editedOrder.order_type === 'MONTHLY_PACKAGE_ORDER' && (
                          <Select
                            fullWidth
                            size="small"
                            value={editedOrder.user_package_id || ''}
                            onChange={(e) => handleInputChange('user_package_id', e.target.value)}
                            displayEmpty
                          >
                            <MenuItem value="" disabled>
                              Chọn gói tháng
                            </MenuItem>
                            {userPackages.map((pkg) => (
                              <MenuItem key={pkg.id} value={pkg.id}>
                                {pkg.package?.name} (Từ: {formatDate(pkg.beginning_date)} - Đến: {formatDate(pkg.ending_date)} - Trạng thái: {pkg.status})
                              </MenuItem>
                            ))}
                          </Select>
                        )}
                      </Box>
                    )}
                  </Box>
                  <Box display="flex" alignItems="center">
                    <LocalPhoneIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                        Điện thoại:{' '}
                        <Typography component="span" color="text.secondary">
                          {order.phone_number}
                        </Typography>
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        value={editedOrder.phone_number}
                        onChange={(e) => handleInputChange('phone_number', e.target.value)}
                        label="Số điện thoại"
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Box>
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box
                  sx={{
                    p: 2,
                    borderRadius: 1,
                    bgcolor: 'white',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                  }}
                >
                  <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <NoteIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography
                        component="span"
                        sx={{
                          px: 1.5,
                          py: 0.5,
                          borderRadius: 1,
                          fontSize: '0.875rem',
                          fontWeight: 'medium',
                          color: 'text.secondary'
                        }}
                      >
                        {order.note || 'Không có ghi chú'}
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        value={editedOrder.note}
                        onChange={(e) => handleInputChange('note', e.target.value)}
                        label="Ghi chú"
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Box >
                  <Box display="flex" alignItems="flex-start" sx={{ mb: 2 }}>
                    <LabelIcon color="primary" sx={{ mr: 1, mt: 0.5 }} />
                    {!isEditing ? (
                      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}>
                        <Typography variant="subtitle1" sx={{ fontWeight: 'medium', mr: 1 }}>
                          Tags:
                        </Typography>
                        {order.tags ? (
                          order.tags.split(',').map((tag, index) => (
                            <Chip
                              key={index}
                              label={tag.trim()}
                              size="small"
                              color="primary"
                              variant="outlined"
                            />
                          ))
                        ) : (
                          <Typography component="span" color="text.secondary">
                            Không có tags
                          </Typography>
                        )}
                      </Box>
                    ) : (
                      <Box sx={{ ml: 1, flex: 1 }}>
                        <TagInput
                          value={editedOrder.tags || ''}
                          onChange={(newTags) => handleInputChange('tags', newTags)}
                          label="Tags"
                          placeholder="Thêm tag và nhấn Enter"
                        />
                      </Box>
                    )}
                  </Box>
                  <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
                    <AttachMoneyIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                        Phí vận chuyển:{' '}
                        <Typography component="span" color="text.secondary">
                          {formatCurrency(order.shipping_price)}
                        </Typography>
                      </Typography>
                    ) : (
                      <Autocomplete
                        fullWidth
                        size="small"
                        value={order.shipping_price || ""}
                        onChange={(event, newValue) => {
                          if (typeof newValue === "number") {
                            handleInputChange("shipping_price", newValue);
                          }
                        }}
                        onInputChange={(event, newInputValue) => {
                          if (/^\d*$/.test(newInputValue)) {
                            handleInputChange("shipping_price", newInputValue === "" ? null : Number(newInputValue));
                          }
                        }}
                        options={[0, 10000, 15000, 20000, 25000, 29000, 39000]}
                        getOptionLabel={(option) =>
                          option === 0 ? "Miễn phí" : new Intl.NumberFormat("vi-VN").format(option)
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Tiền Ship"
                            variant="outlined"
                            size="small"
                            sx={{ ml: 1 }}
                          />
                        )}
                        freeSolo
                      />
                    )}
                  </Box>
                  <Box display="flex" alignItems="center">
                    <LocalShippingIcon color="primary" sx={{ mr: 1 }} />
                    {!isEditing ? (
                      <Typography variant="subtitle1" sx={{ fontWeight: 'medium' }}>
                        Địa chỉ ship:{' '}
                        <Typography component="span" color="text.secondary">
                          {order.shipping_address}
                        </Typography>
                      </Typography>
                    ) : (
                      <TextField
                        fullWidth
                        size="small"
                        value={editedOrder.shipping_address}
                        onChange={(e) => handleInputChange('shipping_address', e.target.value)}
                        label="Địa chỉ"
                        sx={{ ml: 1 }}
                      />
                    )}
                  </Box>
                </Box >
              </Grid >
            </Grid >
            {order.user_package && (
              <Box 
                sx={{ 
                  mt: 2, 
                  p: 1.5, 
                  bgcolor: '#e3f2fd', 
                  borderRadius: 1,
                  border: '1px solid #90caf9'
                }}
              >
                <Typography variant="subtitle2" color="primary" sx={{ fontWeight: 'medium', mb: 1 }}>
                  Thông tin gói tháng của đơn hàng:
                </Typography>
                <Box sx={{ pl: 2 }}>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Tên gói:</strong>{' '}
                    <Button
                      component={Link}
                      to={`/user-packages/${order.user_package.id}`}
                      sx={{
                        p: 0,
                        textTransform: 'none',
                        color: 'primary.main',
                        '&:hover': {
                          textDecoration: 'underline',
                          background: 'none'
                        }
                      }}
                    >
                      {order.user_package.package?.name || 'N/A'}
                    </Button>
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Ngày bắt đầu:</strong> {formatDate(order.user_package.beginning_date)}
                  </Typography>
                  <Typography variant="body2" sx={{ mb: 0.5 }}>
                    <strong>Ngày kết thúc:</strong> {formatDate(order.user_package.ending_date)}
                  </Typography>
                  <Typography variant="body2">
                    <strong>Trạng thái:</strong>{' '}
                    <Typography
                      component="span"
                      sx={{
                        px: 1,
                        py: 0.25,
                        borderRadius: 0.5,
                        fontSize: '0.875rem',
                        bgcolor: order.user_package.status === 'ACTIVE' ? '#e8f5e9' : '#ffebee',
                        color: order.user_package.status === 'ACTIVE' ? '#2e7d32' : '#d32f2f'
                      }}
                    >
                      {order.user_package.status}
                    </Typography>
                  </Typography>
                </Box>
              </Box>
            )}
          </Card >
          <Box sx={{ mb: 2 }}>
            <Grid container spacing={3}>
              {/* S14: one card for the whole billing story — payment status derives
                  from the invoice, actions are grouped inside OrderInvoiceActions. */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap" sx={{ mb: 1.5 }}>
                    <Typography variant="h6">Hóa đơn & Thanh toán</Typography>
                    {/* payment chip */}
                    {(order.order_type === 'INSTANT_ORDER' && orderInvoice
                      ? ['PAID', 'HDDT_CREATED'].includes(orderInvoice.status) || order.financial_status === 'PAID'
                      : order.paid_proof || order.financial_status === 'PAID' || order.financial_status === 'MAPPED_BANK_TRANSACTION') ? (
                      <Chip
                        size="small"
                        label={order.financial_status === 'MAPPED_BANK_TRANSACTION' && !orderInvoice
                          ? 'Đã ghép giao dịch ngân hàng' : 'Đã thanh toán'}
                        sx={{ backgroundColor: '#e8f5e8', color: '#2e7d32', fontWeight: 'medium' }}
                      />
                    ) : (
                      <Chip
                        size="small"
                        label="Chưa thanh toán"
                        sx={{ backgroundColor: '#ffebee', color: '#d32f2f', fontWeight: 'medium' }}
                      />
                    )}
                    {/* sent chip */}
                    {order.invoice_url || order.status === 'SENT_INVOICE' ? (
                      <Chip size="small" label="Đã gửi hóa đơn"
                        sx={{ backgroundColor: '#e8f5e8', color: '#2e7d32', fontWeight: 'medium' }} />
                    ) : (
                      <Chip size="small" label="Chưa gửi hóa đơn"
                        sx={{ backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 'medium' }} />
                    )}
                  </Box>
                  <OrderInvoiceActions
                    order={order}
                    invoice={orderInvoice}
                    onChanged={refreshOrderAndInvoice}
                  />
                </Card>
              </Grid>
              {/* Packing — same layout language as the billing card: header chip,
                  then one labeled action row. */}
              <Grid item xs={12}>
                <Card variant="outlined" sx={{ p: 2 }}>
                  <Box display="flex" alignItems="center" gap={1.5} flexWrap="wrap" sx={{ mb: 1.5 }}>
                    <Typography variant="h6">Đóng gói</Typography>
                    {order.status === 'PACKAGED' || order.status === 'SENT_INVOICE' ? (
                      <Chip size="small" label="Đã đóng gói"
                        sx={{ backgroundColor: '#e8f5e8', color: '#2e7d32', fontWeight: 'medium' }} />
                    ) : (
                      <Chip size="small" label="Chưa đóng gói"
                        sx={{ backgroundColor: '#fff3e0', color: '#e65100', fontWeight: 'medium' }} />
                    )}
                    {(order.status === 'PACKAGED' || order.status === 'SENT_INVOICE') && order.packaged_at && (
                      <Typography variant="body2" color="text.secondary">
                        {formatDateTime(order.packaged_at)}
                        {order.packaged_by_name ? ` · ${order.packaged_by_name}` : ''}
                      </Typography>
                    )}
                  </Box>
                  {/* master feature: admin can reassign packing credit */}
                  {userRole === 'ADMIN' && order.packaged_at && (
                    isChangingPacker ? (
                      <Box display="flex" flexWrap="wrap" alignItems="center" gap={1} sx={{ mb: 1 }}>
                        <FormControl size="small" sx={{ minWidth: 200 }}>
                          <InputLabel>Người đóng gói</InputLabel>
                          <Select
                            value={selectedPackerId}
                            label="Người đóng gói"
                            onChange={(e) => setSelectedPackerId(e.target.value)}
                          >
                            {activeAccounts.map((account) => (
                              <MenuItem key={account.id} value={account.id}>
                                {account.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <Button size="small" variant="contained" onClick={handleChangePacker}
                          disabled={!selectedPackerId}>
                          Lưu
                        </Button>
                        <Button size="small" onClick={() => setIsChangingPacker(false)}>Hủy</Button>
                      </Box>
                    ) : (
                      <Button size="small" variant="outlined" sx={{ mb: 1 }}
                        onClick={handleOpenChangePacker}>
                        Thay đổi người đóng gói
                      </Button>
                    )
                  )}
                  {order.status === "OPEN" && (
                    <Box display="flex" flexWrap="wrap" alignItems="center" gap={1}>
                      <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 600,
                        textTransform: 'uppercase', letterSpacing: 0.5, minWidth: 130 }}>
                        Đóng gói
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={handleMarkAsPackaged}
                      >
                        Đánh dấu đã đóng gói
                      </Button>
                    </Box>
                  )}
                </Card>
              </Grid>
            </Grid>
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-start',
            mt: 2,
          }}>
            {isAddProduct && order.financial_status !== "PAID" && order.status !== "SENT_INVOICE" && !order.paid_proof && order.status !== "CANCELLED" && (
              <Button
                variant="contained"
                startIcon={<AddIcon sx={{ fontSize: '1rem' }} />}
                sx={{
                  ml: 0,
                  px: 2,
                  py: 0.5,
                  borderRadius: 1,
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  bgcolor: '#4caf50',
                  '&:hover': {
                    bgcolor: '#388e3c'
                  }
                }}
                onClick={handleClickAddProduct}
              >
                Thêm sản phẩm
              </Button>
            )}
          </Box>
          <Box sx={{
            mt: 2,
            mb: 4,
            display: { xs: 'block', md: 'none' }
          }}>
            {(order.order_line_items || []).map((item, index) => (
              <Card key={index} sx={{ mb: 2, bgcolor: index % 2 === 0 ? 'white' : '#f5f5f5' }}>
                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {item.product.name}
                      </Typography>
                    </Grid>
                    {item.product.image && (
                      <Grid item xs={12} sx={{ textAlign: 'center' }}>
                        <img
                          src={item.product.image}
                          alt={item.product.name}
                          style={{
                            width: '100%',
                            maxWidth: '150px',
                            height: 'auto',
                            objectFit: 'contain'
                          }}
                        />
                      </Grid>
                    )}
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Số lượng:
                      </Typography>
                      {editingIndex === index ? (
                        <TextField
                          type="text"
                          value={editedQuantity}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (/^\d*\.?\d*$/.test(value)) {
                              setEditedQuantity(value);
                              setOrderLineId(item.id);
                            }
                          }}
                          size="small"
                          fullWidth
                        />
                      ) : (
                          <Typography>{item.quantity}</Typography>
                        )}
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2" color="textSecondary">
                        Đơn giá:
                      </Typography>
                      <Typography>{formatCurrency(item.price)}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="body2" color="textSecondary">
                        Ghi chú:
                      </Typography>
                      <Typography>{item.note || 'Không có'}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="subtitle1" color="primary" fontWeight="bold">
                        Thành tiền: {formatCurrency(item.total_price)}
                      </Typography>
                    </Grid>
                    {(order.status === "CONFIRMING" || order.status === "OPEN" || order.status === "PACKAGED") &&
                      order.financial_status !== "PAID" && (
                        <Grid item xs={12} sx={{ mt: 1 }}>
                          {editingIndex === index ? (
                            <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={handleCancelEditQuantity}
                                fullWidth
                              >
                                Hủy
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                onClick={handleChangeQuantity}
                                fullWidth
                              >
                                Xác nhận sửa
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                onClick={handleDeleteOrderLineItems}
                                fullWidth
                              >
                                Xóa
                              </Button>
                            </Box>
                          ) : (
                              <Button
                                variant="outlined"
                                color="primary"
                                size="small"
                                fullWidth
                                onClick={() => {
                                  handleEditQuantity(index, item.quantity, item.order_type, item.note);
                                  setOrderLineId(item.id);
                                }}
                              >
                                Chỉnh sửa
                              </Button>
                            )}
                        </Grid>
                      )}
                  </Grid>
                </CardContent>
              </Card>
            ))}
          </Box>

          {/* Desktop table view */}
          <TableContainer sx={{
            display: { xs: 'none', md: 'flex' }, // Hide on mobile, show on desktop
            justifyContent: 'center',
            mt: 2,
            mb: 4,
            overflowX: 'auto'
          }}>
            <Table>
              <TableHead>
                <TableRow sx={{ bgcolor: '#1976d2' }}>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Tên sản phẩm</TableCell>
                  <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>Hình ảnh</TableCell>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Số lượng</TableCell>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Ghi chú</TableCell>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Loại đơn</TableCell>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Đơn giá</TableCell>
                  <TableCell align="left" sx={{ color: 'white', fontWeight: 'bold' }}>Thành tiền</TableCell>
                  {(order.status === "CONFIRMING" || order.status === "OPEN" || order.status === "PACKAGED") && order.status !== "CANCELLED"
                    ?
                    <TableCell align="center" sx={{ color: 'white', fontWeight: 'bold' }}>Hành động</TableCell>
                    : null
                  }
                </TableRow>
              </TableHead>
              <TableBody>
                {(order.order_line_items || []).map((item, index) => (
                  <TableRow key={index} sx={{ '&:nth-of-type(odd)': { bgcolor: '#f5f5f5' } }}>
                    <TableCell align="left">{item.product.name}</TableCell>
                    <TableCell align="center">
                      {item.product.image ?
                        <img
                          src={item.product.image}
                          alt={item.product.name}
                          style={{
                            width: '100%',
                            maxWidth: '100px',
                            height: 'auto',
                            maxHeight: '100px',
                            objectFit: 'contain'
                          }}
                        /> : null}
                    </TableCell>
                    <TableCell align="left">
                      {editingIndex === index ? (
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                          <TextField
                            type="text"
                            value={editedQuantity}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (/^\d*\.?\d*$/.test(value)) {
                                setEditedQuantity(value);
                                setOrderLineId(item.id);
                              }
                            }}
                            size="small"
                            sx={{ width: '60px' }}
                          />
                        </Box>
                      ) : (
                          item.quantity
                        )}
                    </TableCell>
                    <TableCell align="left">
                      {editingIndex === index ? (
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                          <TextField
                            type="text"
                            value={editedNote}
                            onChange={(e) => {
                              const value = e.target.value;
                              setEditedNote(value);
                              setOrderLineId(item.id);
                            }}
                            size="small"
                            sx={{ width: '140px' }}
                          />
                        </Box>
                      ) : (
                          item.note
                        )}
                    </TableCell>
                    <TableCell align="left">
                      {editingIndex === index ? (
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
                          <Select
                            value={editedOrderType}
                            onChange={(e) => setEditedOrderType(e.target.value)}
                            size="small"
                            sx={{ width: '100px' }}
                          >
                            <MenuItem value="INSTANT_ORDER">Mua lẻ</MenuItem>
                            <MenuItem value="MONTHLY_PACKAGE_ORDER">Gói tháng</MenuItem>
                          </Select>
                        </Box>
                      ) : (
                          item.order_type === 'MONTHLY_PACKAGE_ORDER' ? 'Gói tháng' : 'Mua lẻ'
                        )}
                    </TableCell>
                    <TableCell align="left">{formatCurrency(item.price)}</TableCell>
                    <TableCell align="left">{formatCurrency(item.total_price)}</TableCell>
                    {
                      (order.status === "CONFIRMING" || order.status === "OPEN" || order.status === "PACKAGED") && order.financial_status !== "PAID" ? (
                        <TableCell align="center">
                          {editingIndex === index ? (
                            <>
                              <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                onClick={handleCancelEditQuantity}
                              >
                                Hủy
                              </Button>
                              <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={handleChangeQuantity}
                              >
                                Xác nhận sửa
                              </Button>
                              <Button
                                variant="contained"
                                color="error"
                                size="small"
                                sx={{ ml: 1 }}
                                onClick={handleDeleteOrderLineItems}
                              >
                                Xóa
                              </Button>
                            </>
                          ) : (
                              <Button
                                variant="outlined"
                                size="small"
                                color="primary"

                                onClick={() => {
                                  handleEditQuantity(index, item.quantity, item.order_type, item.note)
                                  setOrderLineId(item.id);
                                }}
                              >
                                Chỉnh sửa
                              </Button>
                            )}
                        </TableCell>
                      ) : (
                          <></>
                        )
                    }
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
            sx={{
              mt: 4,
              p: 2,
              bgcolor: '#f8f9fa',
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            <AttachMoneyIcon sx={{ mr: 2, fontSize: '2rem', color: 'primary.main' }} />
            <Typography variant="h5" sx={{ fontWeight: 'medium', color: 'primary.main' }}>
              Tổng tiền: {formatCurrency(order.total_price)}
            </Typography>
          </Box>
          {!isAddProduct && (
            <Card sx={{ mt: 4, p: { xs: 2, md: 3 }, bgcolor: '#f8f9fa' }}>
              <Typography
                variant="h5"
                sx={{
                  mb: 3,
                  textAlign: 'center',
                  fontWeight: 'bold',
                  color: 'primary.main'
                }}
              >
                Thêm sản phẩm mới
              </Typography>

              {/* Desktop version */}
              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <TableContainer>
                  <Table>
                    <TableHead>
                      <TableRow sx={{ bgcolor: 'primary.main' }}>
                        <TableCell sx={{ color: 'white' }}>Sản Phẩm</TableCell>
                        <TableCell align="center" sx={{ color: 'white' }}>Số Lượng</TableCell>
                        <TableCell align="center" sx={{ color: 'white' }}>Ghi chú</TableCell>
                        <TableCell align="center" sx={{ color: 'white' }}>Loại đơn</TableCell>
                        <TableCell align="center" sx={{ color: 'white' }}>Thao tác</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow sx={{ bgcolor: 'white' }}>
                        <TableCell sx={{ minWidth: 300 }}>
                          <Autocomplete
                            options={products}
                            getOptionLabel={(option) => option.name || ""}
                            value={products.find(p => p.id === orderItems.product) || null}
                            onChange={(event, newValue) => handleProductChange(newValue ? newValue.id : '')}
                            sx={{ minWidth: 280 }}
                            renderInput={(params) =>
                              <TextField {...params}
                                label="Chọn sản phẩm"
                                variant="outlined"
                                size="small"
                              />
                            }
                            renderOption={(props, option) => {
                              const { key, ...rest } = props;
                              return (
                                <li key={key} {...rest}>
                                  {option.name}
                                  {option.is_combo && (
                                    <Chip label="Combo" size="small" color="secondary" sx={{ ml: 1 }} />
                                  )}
                                </li>
                              );
                            }}
                          />
                        </TableCell>
                        <TableCell align="center">
                          <TextField
                            type="number"
                            value={orderItems.quantity}
                            onChange={(e) => handleQuantityChange(e.target.value)}
                            size="small"
                            sx={{ width: '100px' }}
                            InputProps={{ inputProps: { min: 1 } }}
                          />
                        </TableCell>
                        <TableCell>
                          <TextField
                            value={orderItems.note}
                            onChange={(e) => handleNoteChange(e.target.value)}
                            size="small"
                            fullWidth
                            placeholder="Nhập ghi chú..."
                          />
                        </TableCell>
                        <TableCell align="center">
                          <Select
                            value={orderItems.order_type}
                            onChange={(e) => setOrderItems({ ...orderItems, order_type: e.target.value })}
                            size="small"
                            fullWidth
                            disabled={order.order_type === 'INSTANT_ORDER'}
                          >
                            <MenuItem value="INSTANT_ORDER">Mua lẻ</MenuItem>
                            {order.order_type !== 'INSTANT_ORDER' && (
                              <MenuItem value="MONTHLY_PACKAGE_ORDER">Gói tháng</MenuItem>
                            )}
                          </Select>
                        </TableCell>
                        <TableCell align="center">
                          <Button
                            variant="outlined"
                            color="error"
                            onClick={() => handleRemoveItem()}
                            size="small"
                          >
                            Xóa
                          </Button>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Mobile version */}
              <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <Card sx={{ p: 2, mb: 2, bgcolor: 'white' }}>
                  <Grid container spacing={2}>
                    <Grid item xs={12}>
                      <Autocomplete
                        options={products}
                        getOptionLabel={(option) => option.name || ""}
                        value={products.find(p => p.id === orderItems.product) || null}
                        onChange={(event, newValue) => handleProductChange(newValue ? newValue.id : '')}
                        renderInput={(params) =>
                          <TextField {...params}
                            label="Chọn sản phẩm"
                            variant="outlined"
                            fullWidth
                          />
                        }
                        renderOption={(props, option) => {
                          const { key, ...rest } = props;
                          return (
                            <li key={key} {...rest}>
                              {option.name}
                              {option.is_combo && (
                                <Chip label="Combo" size="small" color="secondary" sx={{ ml: 1 }} />
                              )}
                            </li>
                          );
                        }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Số lượng"
                        type="number"
                        value={orderItems.quantity}
                        onChange={(e) => handleQuantityChange(e.target.value)}
                        fullWidth
                        InputProps={{ inputProps: { min: 1 } }}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <TextField
                        label="Ghi chú"
                        value={orderItems.note}
                        onChange={(e) => handleNoteChange(e.target.value)}
                        fullWidth
                        multiline
                        rows={2}
                        placeholder="Nhập ghi chú..."
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <FormControl fullWidth>
                        <InputLabel>Loại đơn hàng</InputLabel>
                        <Select
                          value={orderItems.order_type}
                          onChange={(e) => setOrderItems({ ...orderItems, order_type: e.target.value })}
                          label="Loại đơn hàng"
                          disabled={order.order_type === 'INSTANT_ORDER'}
                        >
                          <MenuItem value="INSTANT_ORDER">Mua lẻ</MenuItem>
                          {order.order_type !== 'INSTANT_ORDER' && (
                            <MenuItem value="MONTHLY_PACKAGE_ORDER">Gói tháng</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                    </Grid>
                    <Grid item xs={12}>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={() => handleRemoveItem()}
                        fullWidth
                      >
                        Xóa
                      </Button>
                    </Grid>
                  </Grid>
                </Card>
              </Box>

              {/* Action buttons for both versions */}
              <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                gap: 2,
                mt: 3
              }}>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleClickAddProduct}
                  sx={{
                    minWidth: { xs: '120px', sm: '150px' },
                    py: 1
                  }}
                >
                  Hủy
                </Button>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleAddProduct}
                  sx={{
                    minWidth: { xs: '120px', sm: '150px' },
                    py: 1
                  }}
                >
                  Thêm
                </Button>
              </Box>
            </Card>
          )}
          {/* --- Custom: Order meta info --- */}
        </CardContent >
      </Card >

      {/* Order Activity History */}
      <OrderActivityHistory orderId={id} />

      {/* Inventory Warning Confirmation Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleCancelConfirm}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle sx={{ bgcolor: '#fff3e0', display: 'flex', alignItems: 'center', gap: 1 }}>
          <WarningIcon color="warning" />
          Cảnh báo tồn kho không đủ
        </DialogTitle>
        <DialogContent sx={{ mt: 2 }}>
          <Alert severity="warning" sx={{ mb: 2 }}>
            Một số sản phẩm không đủ tồn kho. Bạn có chắc chắn muốn thêm sản phẩm này?
          </Alert>
          <TableContainer>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell><strong>Sản phẩm</strong></TableCell>
                  <TableCell><strong>Từ Combo</strong></TableCell>
                  <TableCell align="right"><strong>Yêu cầu</strong></TableCell>
                  <TableCell align="right"><strong>Tồn kho</strong></TableCell>
                  <TableCell align="right"><strong>Thiếu</strong></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {inventoryWarnings.map((warning, index) => (
                  <TableRow key={index}>
                    <TableCell>{warning.product_name}</TableCell>
                    <TableCell>
                      {warning.from_combo ? (
                        <Chip label={warning.from_combo} size="small" color="secondary" />
                      ) : (
                        <Typography variant="body2" color="text.secondary">-</Typography>
                      )}
                    </TableCell>
                    <TableCell align="right">{warning.requested_quantity}</TableCell>
                    <TableCell align="right">{warning.available_quantity}</TableCell>
                    <TableCell align="right" sx={{ color: 'error.main', fontWeight: 'bold' }}>
                      -{warning.shortage}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCancelConfirm} variant="outlined">
            Hủy
          </Button>
          <Button onClick={handleConfirmAddProduct} variant="contained" color="warning">
            Vẫn thêm sản phẩm
          </Button>
        </DialogActions>
      </Dialog>
    </Container >
  );
};
export default OrderDetail;
